import trackEvent from '../../helpers/gtm/eventPush';

const multiAdLink = document.querySelector('.purchase_multi_ad_package');
export function trackingMultiAdLink() {
  if (multiAdLink) {
    trackEvent({
      category: 'ads',
      action: 'room_offered_form_upgrade_required_msg_view',
      label: `${window._sr.page.loginReturnPath}`,
      non_interaction: true,
    });
    multiAdLink.addEventListener('click', () => {
      trackEvent({
        category: 'ads',
        action: 'room_offered_form_upgrade_required_msg_click',
        label: `${window._sr.page.loginReturnPath}`,
      });
    });
  }
}

export function trackingSubmitionError() {
  const submissionError = document.querySelector('.submission-error');
  if (submissionError) {
    trackEvent({
      category: 'Form error',
      action: '',
      label: `${submissionError.innerHTML}`,
    });
  }
}
